import { ArrowTooltip } from '@/components/arrow-tooltip.js';

export function GoogleMeetNotesCell({ notes }: { notes: string | null }) {
  if (!notes) return '–';

  return (
    <ArrowTooltip
      position="bottom"
      asChild
      trigger={
        <div
          tabIndex={0}
          className="max-w-72 whitespace-pre-wrap line-clamp-2 rounded-sm text-left outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          {notes}
        </div>
      }
    >
      <div className="max-w-md whitespace-pre-wrap text-left">{notes}</div>
    </ArrowTooltip>
  );
}
